import { REST_LIST, SET_USER } from './types';

export default {
  /**
   * Store list with restaurants objects
   */
  [REST_LIST]: (state, data) => {
    state.restaurants = data;
  },
  /**
   * Store user data.
   */
  [SET_USER]: (state, data) => {
    state.userAccountData = data;
  },
};




// WEBPACK FOOTER //
// ./src/apps/desktop/store/mutations.js